import React, {useContext, useEffect, useRef, useState} from 'react';
import {
    Autocomplete,
    Avatar,
    Button, Card, CardActions, CardContent, CardMedia, Checkbox,
    Chip,
    Dialog, DialogActions, DialogContent, DialogContentText,
    DialogTitle,
    FormControl, FormControlLabel, FormGroup,
    InputLabel,
    MenuItem,
    Select,
    TextField
} from "@mui/material";
import Grid from '@mui/material/Grid';
import {useNavigate} from "react-router-dom";
import "./attendees.css";
import country_codes from "../../../sampleData/PhonePrefixes";
import PAAttendee from "../../../MasterEventObjects/Attendee";
import {PAContext} from "../../../Services/PAContext";
import Typography from "@mui/material/Typography";

import helloHeaderImage from '../../../graphics/Hello_Header_Large.jpg';
import rsvpHeaderImage from '../../../graphics/rsvp.png';
import {addChipStyle} from "../../ButtonStyle/Add";
import {cancelChipStyle} from "../../ButtonStyle/Cancel";
import usePA_GlobalStore from "../../../Services/ZustandGlobalStore";
import Box from "@mui/material/Box";
import {DatePicker} from "@mui/x-date-pickers";
import dayjs from "dayjs";
import {supportedLanguages} from "../../../sampleData/PreferredLanguages";
import {_airports_list} from "../../../sampleData/airline_data";

function AttendeesAddNew(props) {

    const inputRef = useRef(null);
    const navigate = useNavigate();

    const { PA_GlobalObject, set_PA_GlobalObject } = usePA_GlobalStore();

    const { sendSocketMessage } = useContext(PAContext);

    const [ attendeeAvatar, setAttendeeAvatar] = useState({});
    const [fname,setFname] = useState("");
    const [lname,setLname] = useState("");
    const [nickname,setNickname] = useState("");
    const [address,setAddress] = useState("");
    const [city,setCity] = useState("");
    const [state,setState] = useState("");
    const [zip,setZip] = useState("");
    const [country,setCountry] = useState("");
    const [email,setEmail] = useState("");
    const [phonePrefix,setPhonePrefix] = useState("");
    const [phone,setPhone] = useState("");

    const [welcomeRequested,setWelcomeRequested] = useState(false);
    const [welcomeMessage,setWelcomeMessage] = useState("You can add a personal message here that will be included in the email.");
    const [rsvpRequested,setRsvpRequested] = useState(false);

    // Function to handle file change and set the avatar
    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onloadend = () => {
            const base64data = reader.result;

            setAttendeeAvatar(prev => (
                {
                    preview: base64data, // This is base64 string of image
                    name: file.name,
                    type: file.type,
                    size: file.size,
                    hasBeenUpdated: true,
                }
            ));

        };

        reader.readAsDataURL(file);
    };

    function handleFnameChange(event){
        const newValue = event.target.value;
        const capitalizedValue = newValue
            .toLowerCase()
            .split(' ')
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');

        setFname(capitalizedValue);
        setNickname(capitalizedValue);
    }
    function handleLnameChange(event){
        const newValue = event.target.value;
        const capitalizedValue = newValue
            .toLowerCase()
            .split(' ')
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');

        setLname(capitalizedValue);

    }
    function handleNicknameChange(event){
        const newValue = event.target.value;
        const capitalizedValue = newValue
            .toLowerCase()
            .split(' ')
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');

        setNickname(capitalizedValue);

    }

    function handleAddressChange(event){
        setAddress(event.target.value);
    }
    function handleCityChange(event){
        setCity(event.target.value);
    }
    function handleStateChange(event){
        setState(event.target.value);
    }
    function handleZipChange(event){
        setZip(event.target.value);
    }
    function handleCountryChange(event){
        setCountry(event.target.value);
    }

    function handleEmailChange(event){
        setEmail(event.target.value);
    }

    function handlePhonePrefixChange(event){
        console.log("setting phone prefix to : "+event.target.value);
        setPhonePrefix(event.target.value);
    }
    function handlePhoneChange(event){
        console.log("setting phone prefix to : "+event.target.value);

        if (phonePrefix === "+1"){
            //format for area code
            const input = event.target.value.replace(/\D/g, ''); // Remove non-numeric characters
            let formattedNumber = input;

            if (input.length >= 3) {
                formattedNumber = `(${input.slice(0, 3)})`;

                if (input.length > 3) {
                    formattedNumber += ` ${input.slice(3, 6)}`;

                    if (input.length > 6) {
                        formattedNumber += `-${input.slice(6, 10)}`;
                    }
                }
            }
            setPhone(formattedNumber);
        } else {
            setPhone(event.target.value);
        }

    }

    const [dob,setDOB] = useState("");
    const [language,setLanguage] = useState("en");
    const [preferredAirport,setPreferredAirport] = useState("");
    function handleDOBChange(newValue) {
        const today = dayjs();

        // If user cleared the field
        if (!newValue) {
            setDOB("");
            return;
        }

        // If it's not a valid date
        if (!newValue.isValid()) {
            setDOB("");
            return;
        }

        // If date is *after today*, reject it
        if (newValue.isAfter(today, "day")) {
            // Optional: clamp to today instead of clearing
            // setDOB(today.format("YYYY-MM-DD"));
            return; // Just prevent invalid future DOB
        }

        // Otherwise accept it
        setDOB(newValue.format("YYYY-MM-DD"));
    }
    function handleLanguageChange(event){
        setLanguage(event.target.value);
    }
    function handlePreferredAirportChange(event){
        console.log("changed preferred airport to : "+ event.target.value);
        setPreferredAirport(event.target.value);
    }

    function handleWelcomeRequested(){
        console.log("handleWelcomeRequested");
        setWelcomeRequested(!welcomeRequested);
    }
    function handleWelcomeMessage(event){
        setWelcomeMessage(event.target.value);
    }
    function handleRsvpRequested(){
        console.log("handleRsvpRequested");
        setRsvpRequested(!rsvpRequested);
    }


    useEffect(() => {

        const autocomplete = new window.google.maps.places.Autocomplete(inputRef.current);
        autocomplete.addListener('place_changed', () => {
            const place = autocomplete.getPlace();
            console.log(JSON.stringify(place, null, '\t'));
            console.log(place.formatted_address);

            let _address_line = "";
            let _address_city = "";
            let _address_state = "";
            let _address_zip = "";
            let _address_country = "";

            let _route_exists = false;
            let _country_code = "";
            for (const component of place.address_components){
                if (component.types.includes("route")) {
                    _route_exists = true;
                } else if (component.types.includes("country")){
                    _country_code = component.short_name;
                }
            }

            place.address_components.forEach((component) => {
                if (component.types.includes("street_number")){
                    _address_line = component.long_name;
                } else if (component.types.includes("route")){
                    _address_line += " "+component.long_name;
                } else if (!_route_exists && component.types.includes("administrative_area_level_2")){
                    _address_line += " "+component.long_name;
                } else if (component.types.includes("locality") || component.types.includes("postal_town")){
                    _address_city = component.long_name;
                } else if (component.types.includes("administrative_area_level_1") && _country_code === "US"){
                    _address_state = component.short_name;
                } else if (component.types.includes("postal_code")){
                    _address_zip = component.long_name;
                } else if (component.types.includes("country")){
                    if (_country_code !== "US"){
                        _address_state = component.long_name;
                    }
                    _address_country = component.short_name;
                }
            });

            if (_address_line === ""){
                //try getting it from the formatted address
                try {
                    const _f_address_pieces = place.formatted_address.split(',');
                    if (_f_address_pieces[0] !== ""){
                        _address_line = _f_address_pieces[0].trim();
                    }
                } catch (e){}
            }

            console.log("the _address_line : "+_address_line);
            console.log("the _address_city : "+_address_city);
            console.log("the _address_state : "+_address_state);
            console.log("the _address_zip: "+_address_zip);
            console.log("the _address_country: "+_address_country);

            setAddress(_address_line);
            setCity(_address_city);
            setState(_address_state);
            setZip(_address_zip);
            setCountry(_address_country);

        });

    }, []);


    function handleAttendeeAddOK() {
        console.log("handleAttendeeAddOK");


        if (fname !== "" && lname !== ""){
            console.log("names are ok");

            if ((welcomeRequested || rsvpRequested) && email === ""){
                //email address needed or unselect the checkboxes
                console.log("welcomeRequested : "+welcomeRequested);
                console.log("rsvpRequested : "+rsvpRequested);
                console.log("email : "+email);

            } else {

                if (PA_GlobalObject.Planning.status!== 10) {
                    const _new_attendee = new PAAttendee();
                    _new_attendee.fname = fname;
                    _new_attendee.lname = lname;
                    _new_attendee.nickname = nickname;

                    _new_attendee.address = address;
                    _new_attendee.city = city;
                    _new_attendee.state = state;
                    _new_attendee.zip = zip;
                    _new_attendee.country = country;

                    _new_attendee.email = email;

                    _new_attendee.phone_prefix = phonePrefix;
                    _new_attendee.phone = phone;

                    _new_attendee.dob = dob;
                    _new_attendee.language = language;
                    _new_attendee.preferred_airport = preferredAirport;

                    _new_attendee.welcome_requested = welcomeRequested;
                    _new_attendee.welcome_message = welcomeMessage;

                    _new_attendee.rsvp_requested = rsvpRequested;

                    console.log("new attendee : "+JSON.stringify(_new_attendee, null, '\t'));

                    //update the current Planning
                    /*
                    set_PA_GlobalObject(prev => ({
                        Planning: {
                            ...prev.Planning,
                            attendees: [...prev.Planning.attendees, _new_attendee],
                        },
                    }));

                     */

                    //update the dataArray.Attendees
                    //addAttendee(_new_attendee);

                    //send new attendee info to server
                    const _sendString = {};
                    _sendString.action = "E_addNewAttendeeFromFields";
                    _sendString.event_id = PA_GlobalObject.Planning.id;
                    _sendString.image = "";
                    _sendString.avatar = attendeeAvatar;
                    _sendString.fname = fname;
                    _sendString.lname = lname;
                    _sendString.nickname = nickname;

                    _sendString.address = address;
                    _sendString.city = city;
                    _sendString.state = state;
                    _sendString.zip = zip;
                    _sendString.country = country;

                    _sendString.phone_prefix = phonePrefix;
                    _sendString.phone = phone;

                    _sendString.email = email;

                    _sendString.dob = dob;
                    _sendString.language = language;
                    _sendString.preferred_airport = preferredAirport;

                    _sendString.send_welcome_message = welcomeRequested;
                    _sendString.welcome_message = welcomeMessage;
                    _sendString.rsvp_request = rsvpRequested;

                    console.log("sendString : ", _sendString);
                    sendSocketMessage(_sendString);

                }


                //go back to the attendee list
                navigate('/Planner/Attendees');

            }

        } else {
            //turn them red

        }

    }


    function handlePromptAddNewClose() {
        navigate('/Planner/Attendees')
    }



    const [openAddressExplanationDialog, setOpenAddressExplanationDialog] = useState(false);

    function handleOpenAddressExplanationDialog (){
        setOpenAddressExplanationDialog(true);
    }
    function handleAddressExplanationDialogClose(){
        setOpenAddressExplanationDialog(false);
    }


    return (

        <div className="attendee-list-container">
            {/* show the header */}
            <div
                className="attendee-list-header"
            >
                <div className="attendee-list-header-text">
                    <h5>New Attendee</h5>
                </div>
                <div className="attendee-list-header-chip-holder">
                    <Chip
                        sx={cancelChipStyle}
                        label="Cancel"
                        size="small"
                        color="error"
                        onClick={handlePromptAddNewClose}
                    />
                    <Chip
                        sx={addChipStyle}
                        label="Add"
                        size="small"
                        onClick={handleAttendeeAddOK}
                    />
                </div>
            </div>


            {/* show all the fields */}
            <div
                className={
                    props.showingPageHeader
                        ? "attendee-list-items-container with-header"
                        : "attendee-list-items-container"
                }
            >

                <Grid container spacing={2} direction="column" sx={{marginTop: '0'}}>
                    <Grid item style={{flex: '1'}}>
                        {/* Avatar Upload Section */}
                        <Box sx={{display: 'flex', alignItems: 'center', gap: 2}}>
                            <input
                                type="file"
                                id={`file-input-new-attendee`}
                                accept="image/*"
                                style={{display: 'none'}}
                                onChange={(e) => handleImageChange(e)}
                            />
                            <Avatar
                                src={
                                    attendeeAvatar?.preview || ''
                                }
                                alt="Attendee Avatar"
                                sx={{width: 64, height: 64, cursor: 'pointer'}}
                                onClick={() => document.getElementById('file-input-new-attendee').click()}
                            />
                            <Typography variant="body2" color="text.secondary">
                                Click Avatar to upload or replace
                            </Typography>
                        </Box>
                    </Grid>

                    <Grid item style={{flex: '1'}}>
                        <TextField
                            fullWidth
                            id="fname"
                            label="First Name"
                            required
                            value={fname}
                            onChange={handleFnameChange}
                        />
                    </Grid>

                    <Grid item style={{flex: '1'}}>
                        <TextField
                            fullWidth
                            id="lname"
                            label="Last Name"
                            required
                            value={lname}
                            onChange={handleLnameChange}
                        />
                    </Grid>

                    <Grid item style={{flex: '1'}}>
                        <TextField
                            fullWidth
                            id="nickname"
                            label="Nickname"
                            value={nickname}
                            onChange={handleNicknameChange}
                        />
                    </Grid>

                    <Grid item style={{flex: '1', position: 'relative'}}>
                        <TextField
                            fullWidth
                            id="address"
                            label="Address"
                            value={address}
                            onChange={handleAddressChange}
                            inputRef={inputRef}
                        />
                        <i
                            className="icon-question-circle"
                            style={{position: 'absolute', top: '15px', right: '0', color: 'green', cursor: 'pointer'}}
                            onClick={handleOpenAddressExplanationDialog}
                        />
                        <Dialog
                            open={openAddressExplanationDialog}
                            onClose={handleAddressExplanationDialogClose}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">
                                {"What is this used for?"}
                            </DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Knowing the Attendees address allows us to provide the following:
                                </DialogContentText>
                                <DialogContentText id="alert-dialog-description">
                                    <strong>Transportation</strong> : We can show routes to the destination
                                </DialogContentText>
                                <DialogContentText id="alert-dialog-description">
                                    <strong>Flights</strong> : We can show flight prices for trips where a flight might
                                    be involved.
                                </DialogContentText>
                                <DialogContentText id="alert-dialog-description">
                                    <strong>Timezone</strong> : Before and after the trip we can send scheduled
                                    reminders at the correct time.
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={handleAddressExplanationDialogClose} autoFocus>
                                    OK
                                </Button>
                            </DialogActions>
                        </Dialog>
                    </Grid>

                    <Grid item style={{flex: '1'}}>
                        <TextField
                            fullWidth
                            id="city"
                            label="City"
                            value={city}
                            onChange={handleCityChange}
                        />
                    </Grid>

                    <Grid item style={{flex: '1'}}>
                        <TextField
                            fullWidth
                            id="state"
                            label="State"
                            value={state}
                            onChange={handleStateChange}
                        />
                    </Grid>

                    <Grid item style={{flex: '1'}}>
                        <TextField
                            fullWidth
                            id="zip"
                            label="Zip"
                            value={zip}
                            onChange={handleZipChange}
                        />
                    </Grid>

                    <Grid item style={{flex: '1'}}>
                        <TextField
                            fullWidth
                            id="country"
                            label="Country"
                            value={country}
                            onChange={handleCountryChange}
                        />
                    </Grid>

                    <Grid item style={{flex: '1'}}>
                        <TextField
                            fullWidth
                            id="email_address"
                            label="Email"
                            type="email"
                            value={email}
                            onChange={handleEmailChange}
                            helperText="Required if they are going to be logging in"
                        />
                    </Grid>

                    <Grid item style={{flex: '1'}}>
                        <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-standard-label">Phone Prefix</InputLabel>
                            <Select
                                labelId="demo-simple-select-standard-label"
                                id="demo-simple-select-standard"
                                value={phonePrefix}
                                onChange={handlePhonePrefixChange}
                                label="Phone Prefix"
                            >
                                <MenuItem value="">
                                    <em>None</em>
                                </MenuItem>
                                {
                                    country_codes.map((item, index) => (
                                        <MenuItem key={index} value={item.dialCode}>
                                            {item.dialCode} : {item.name}
                                        </MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item style={{flex: '1'}}>
                        <TextField
                            fullWidth
                            id="phone"
                            label="Phone"
                            value={phone}
                            onChange={handlePhoneChange}
                        />
                    </Grid>

                    <Grid item style={{flex: '1'}}>
                        <DatePicker
                            sx={{width: '100%'}}
                            label="Date of Birth"
                            value={dob ? dayjs(dob, 'YYYY-MM-DD') : null}
                            onChange={handleDOBChange}
                            maxDate={dayjs()}
                        />

                    </Grid>

                    <Grid item style={{flex: '1'}}>
                        <FormControl fullWidth>
                            <InputLabel id="language-label">Preferred Language</InputLabel>
                            <Select
                                labelId="language-label"
                                id="preferred-language-select"
                                value={language}
                                label="Preferred Language"
                                onChange={handleLanguageChange}
                            >
                                {supportedLanguages.map((lang) => (
                                    <MenuItem key={lang.code} value={lang.code}>
                                        {lang.label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item style={{flex: '1'}}>
                        <Autocomplete
                            fullWidth
                            options={_airports_list}
                            getOptionLabel={(option) => `${option.iata} : ${option.name}`}
                            value={_airports_list.find((item) => item.iata === preferredAirport) || null}
                            onChange={(event, newValue) => {
                                handlePreferredAirportChange({target: {value: newValue ? newValue.iata : ''}});
                            }}
                            renderInput={(params) => (
                                <TextField {...params} label="Preferred Airport"/>
                            )}
                            isOptionEqualToValue={(option, value) => option.iata === value.iata}
                        />
                    </Grid>

                    {/* add the Welcome option */}
                    <Card>
                        <CardMedia
                            sx={{height: 140}}
                            image={helloHeaderImage}
                            title="welcome email"
                        />
                        <CardContent>
                            <Typography gutterBottom variant="h7" component="div">
                                Send Welcome Email
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                We will send {fname} a welcome email that includes a link
                                so they can login and start engaging.
                            </Typography>
                        </CardContent>
                        <CardContent>
                            <TextField
                                fullWidth
                                id="standard-multiline-static"
                                multiline
                                rows={4}
                                defaultValue={welcomeMessage}
                                onChange={handleWelcomeMessage}
                                variant="standard"
                            />
                        </CardContent>
                        <CardActions sx={{justifyContent: 'flex-end'}}>
                            <FormGroup>
                                <FormControlLabel
                                    sx={{fontSize: '12px'}}
                                    control={
                                        <Checkbox
                                            checked={welcomeRequested}
                                            onChange={handleWelcomeRequested}
                                            inputProps={{'aria-label': 'controlled'}}
                                        />
                                    }
                                    label="Yes, please"
                                    labelPlacement="start"
                                />
                            </FormGroup>
                        </CardActions>
                    </Card>

                    {/* add the RSVP option */}
                    <Card>
                        <CardMedia
                            sx={{height: 140}}
                            image={rsvpHeaderImage}
                            title="rsvp email"
                        />
                        <CardContent>
                            <Typography gutterBottom variant="h7" component="div">
                                Send RSVP Email
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                We will send {fname} an email that includes buttons where they can RSVP right
                                from the email.
                            </Typography>
                        </CardContent>
                        <CardActions sx={{justifyContent: 'flex-end'}}>
                            <FormGroup>
                                <FormControlLabel
                                    sx={{fontSize: '12px'}}
                                    control={
                                        <Checkbox
                                            checked={rsvpRequested}
                                            onChange={handleRsvpRequested}
                                            inputProps={{'aria-label': 'controlled'}}
                                        />
                                    }
                                    label="Yes, please"
                                    labelPlacement="start"
                                />
                            </FormGroup>
                        </CardActions>
                    </Card>

                </Grid>

            </div>
        </div>
    )
}

export default AttendeesAddNew;
